import { render, staticRenderFns } from "./ClinicDashboard.vue?vue&type=template&id=015288dc&scoped=true"
import script from "./ClinicDashboard.vue?vue&type=script&lang=js"
export * from "./ClinicDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClinicDashboard.vue?vue&type=style&index=0&id=015288dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015288dc",
  null
  
)

export default component.exports